<div *ngIf="isWebView">
  <app-webviews></app-webviews>
</div>

<div *ngIf="!isWebView">
  <app-app-main-component *ngIf="isLeftMenuVisible"></app-app-main-component>
  <app-app-sub-component *ngIf="!isLeftMenuVisible"></app-app-sub-component>
</div>

<div class="loader" [ngStyle]="{ display: loader ? 'block' : 'none' }"></div>
<app-loader></app-loader>